import {tokenProvider} from "./tokenProvider";
import {persistor, store} from "../store";
import {api} from "../store/emptyApi";
import {authServiceRtk} from "./authService";

/**
 * Clears tokens and cached state, then restarts login — the JWT must be re-issued for the new email.
 * `returnParams` are added to the post-login URL so the portal can react once the user is back.
 */
export function reauthenticate(returnParams?: Record<string, string>): void {
    tokenProvider.clearTokens();
    persistor.purge();
    store.dispatch(api.util.resetApiState());

    const searchParams = new URLSearchParams(window.location.search);
    Object.entries(returnParams ?? {}).forEach(([key, value]) => searchParams.set(key, value));
    const query = searchParams.toString();
    const redirectPath = window.location.pathname + (query ? `?${query}` : "");

    setTimeout(async () => {
        await authServiceRtk.initiateLogin(redirectPath);
    }, 2000);
}
